<template>
  <PageLayout
    :page-title="pageTitle"
    :show-breadcrumbs="false"
    :breadcrumb-items="breadcrumbItems"
    :locale="locale"
  >
    <template #headerActions>
      <ViewCustomerStatementButton :customer-id="customerId"/>
    </template>

    <template #pageHeaderActions>
      <button
        class="btn btn-primary first-button"
        @click="goToCreateContact"
      >
        <i class="fas fa-plus"></i> New {{ $t('sidebar.owner') }}
      </button>
    </template>

    <div> <!-- <div class="col-md-12" -->
      <div class="card">
        <div class="card-body">
          <ContactsPageBody ref="contactsPageBody"/>
        </div>
      </div>
    </div>

    <!-- Filter Drawer -->
    <ContactsFilterDrawer
      :is-open="isFilterDrawerOpen"
      :initial-filters="advancedFilters"
      :contact-types="contactSearchTypes"
      @close="closeFilterDrawer"
      @filters-updated="handleFilterUpdate"
    />
    <div class="filter-overlay" :class="{ 'show': isFilterDrawerOpen }" @click="closeFilterDrawer"></div>
  </PageLayout>
</template>

<script>
import PageLayout from "../layouts/PageLayout.vue";
import ContactsPageBody from "./ContactsPageBody.vue";
import {handleError, showSuccess, showWarning} from "../../utils/notification.utils";
import ViewCustomerStatementButton from "../shared/ViewCustomerStatementButton.vue";
import contactService from "../../service/contact.service";
import ContactsFilterDrawer from "./ContactsFilterDrawer.vue";
import {relationshipTypes} from "../../utils/relationship.types";

export default {
  name: "ContactsPage",
  components: {
    ContactsFilterDrawer,
    ViewCustomerStatementButton,
    PageLayout,
    ContactsPageBody,
  },
  data() {
    return {
      pageTitle: this.$t('sidebar.owners'),
      locale: this.$i18n.locale,
      customer: {},
      customerId: null,
      activeTab: 'customer-invoices',
      pageTabs: [],
      breadcrumbItems: [
        {label: 'Home', to: '/dashboard'},
        {label: this.$t('sidebar.owners'), to: '/contacts'},
      ],
      contactSearchTypes: [
        {label: 'All', value: 'ALL'}
      ],
      defaultContactTypeId: 'ALL',
      isFilterDrawerOpen: false,
      advancedFilters: null
    };
  },
  methods: {
    toggleFilterDrawer() {
      this.isFilterDrawerOpen = !this.isFilterDrawerOpen;
      if (this.isFilterDrawerOpen) {
        document.body.classList.add('drawer-open');
      } else {
        document.body.classList.remove('drawer-open');
      }
    },

    closeFilterDrawer() {
      this.isFilterDrawerOpen = false;
      document.body.classList.remove('drawer-open');
    },

    handleFilterUpdate(filters) {
      // Store all filters for use in contacts retrieval
      this.advancedFilters = filters;

      // Apply filters to contacts
      if (this.$refs.contactsPageBody) {
        this.$refs.contactsPageBody.retrieveContacts(filters);
      }

      // Always close the drawer after applying filters
      this.closeFilterDrawer();
    },

    goToCreateContact() {
      this.$router.push('/contacts/create');
    },
    deleteCustomer(customerId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then(result => {
        if (result.isConfirmed) {
          contactService.delete(localStorage.getItem("mid"), customerId)
            .then(response => {
              if (response.data.success) {
                showSuccess('Successfully deleted');
                this.$router.push('/customers');
              } else {
                showWarning(response.data.narrative);
              }
            })
            .catch(e => handleError(e));
        }
      });
    }
  },
  async mounted() {
    this.customerId = this.$route.params.id;

    if (!this.$store.state.auth.user) {
      await this.$router.push('/login');
      return;
    }

    const types = relationshipTypes.filter(relationshipType => relationshipType.industries.includes(this.$i18n.locale))
    this.contactSearchTypes = [
      {label: 'All', value: 'ALL'},
      ...types.map(type => ({label: type.name, value: type.id}))
    ];
  }
};
</script>

<style scoped>
/* Filter overlay */
.filter-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.filter-overlay.show {
  opacity: 1;
  visibility: visible;
}

/* Prevent body scroll when drawer is open */
:global(body.drawer-open) {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/ContactsPage.vue